import { ca } from "intl-tel-input/i18n";
import CartInitialState from "./cart.initialstate";
import { SET_CART_LIST, SET_CART_CLEAR } from "./cart.types";


const cartReducer = (state = CartInitialState, action) => {


    switch (action.type) {

        case SET_CART_LIST:
            return {
                ...state,
                people: action.payload.people,
                selectedDate: action.payload.selectedDate,
                selectedRate: action.payload.selectedRate,
                selectdTime: action.payload.selectdTime,
                product: action.payload.product,
                priceList: action.payload.priceList,
                cartSession: action.payload.cartSession,
                date: Date.now(),
            }

        case SET_CART_CLEAR:
            return {
                ...state,
                people: null,
                selectedDate: null,
                product: null,
                selectedRate: null,
                selectdTime: null,
                priceList: null,
                cartSession: null,
                date: null,
            }
    

        default:
            return state;
    }
};

export default cartReducer;